export const relativeContextReducerKey = 'relativeContext';

export const saveRelativeContextType = 'saveRelativeContextType';
export const clearRelativeContextType = 'clearRelativeContextType';
